<template>
    <div class="row">
      <div class="col-md-6">
        <nav v-if="items > 1">
            <ul class="pagination">
                <li class="page-item">
                    <button class="page-link" href="#"  @click.prevent="prevPage()" :disabled="current == 1">Anterior</button>
                </li>
                <li class="page-item" :class="{'active' : current == 1}"><a @click.prevent="setPage(1)" class="page-link" href="#">1</a></li>
                <template v-for="key in pages">
                    <li 
                    class="page-item" 
                    :class="{'active' : current == key}">
                      <a @click.prevent="setPage(key)" class="page-link" href="#">
                        {{key}}
                      </a>
                    </li>
                </template>
                <li class="page-item" :class="{'active' : current == items}"><a @click.prevent="setPage(items)" class="page-link" href="#">{{items}}</a></li>
                <li class="page-item">
                    <button class="page-link" href="#" @click.prevent="nextPage()" :disabled="current == items">Sigiuente</button>
                </li>
            </ul>
        </nav>
      </div>
      <div class="quantity-aligment col-md-6" v-if="typeof quantity !== 'undefined'">
        {{quantity}} contribuyentes
      </div> 
    </div>
    
</template>
<script>
export default {
  name: 'pagination',
  props: ['items', 'current', 'quantity'],
  data: function () {
    return {}
  },
  methods: {
    setPage: function (item) {
      this.$emit('page', item)
    },
    prevPage: function () {
      var item = this.current
      item--
      this.$emit('page', item)
    },
    nextPage: function () {
      var item = this.current
      item++
      this.$emit('page', item)
    }
  },
  computed: {
    pages () {
      let pages = []
      for (var i = 2; i < this.items; i++) {
        pages.push(i)
      }
      if (this.items <= 10) {
        return pages
      }
      let current = this.current
      if (this.current === 1) {
        current = this.current - 1 // 4
      } else {
        current = this.current - 2 // 4
      }
      let next = this.current + 2 // 10
      let renderpages = pages.slice(current, next)
      if (this.current > 3) {
        current = this.current - 2
        let before = current - 2
        let beforePages = pages.slice(before, current)
        renderpages = beforePages.concat(renderpages)
      } else if (this.current === 3) {
        current = this.current - 2
        let before = current - 1
        let beforePages = pages.slice(before, current)
        renderpages = beforePages.concat(renderpages)
      }
      // console.log(this.current, current)
      return renderpages
    }
  }
}
</script>
<style>
.quantity-aligment {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/components/Pagination.vue